/* Liste déroulante habillée.

   Le menu qu'ouvre un <select> natif est dessiné par le système : ni sa
   bordure noire, ni sa ligne bleue de sélection, ni sa police ne sont
   atteignables par une feuille de style. Pour le tri de la page collection,
   dont la maquette fixe l'apparence, il faut donc dessiner nous-mêmes.

   Le <select> reste dans le document et demeure la source de vérité : c'est
   lui qui porte la valeur, lui que le formulaire soumet, lui qui répond sans
   JavaScript. On le masque à l'œil, on lui retire le focus, et on pose à côté
   un bouton et une liste que l'on tient synchronisés. Si ce script ne
   s'exécute pas, la page garde un tri parfaitement fonctionnel.

   Le clavier suit le motif attendu pour une liste de ce type : flèches pour
   parcourir, Origine et Fin pour les extrémités, Entrée ou Espace pour
   valider, Échap pour renoncer, et la saisie des premières lettres pour
   atteindre une option directement.
*/

(function siritoSelect() {
  if (customElements.get('sirito-select')) return;

  const DELAI_SAISIE = 600;

  class SiritoSelect extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('select');
      if (!this.select) return;

      this.options = Array.from(this.select.options);
      this.index = this.select.selectedIndex;
      this.recherche = '';
      this.horloge = null;

      this.construire();
      this.brancher();
    }

    construire() {
      const id = this.select.id || 'SiritoSelect';

      // Le natif reste présent mais hors de portée : ni à l'œil, ni au
      // clavier, ni pour les technologies d'assistance — le bouton le
      // remplace intégralement.
      this.select.classList.add('sirito-select__natif');
      this.select.setAttribute('tabindex', '-1');
      this.select.setAttribute('aria-hidden', 'true');

      this.bouton = document.createElement('button');
      this.bouton.type = 'button';
      this.bouton.className = 'sirito-select__bouton';
      this.bouton.id = id + 'Bouton';
      this.bouton.setAttribute('aria-haspopup', 'listbox');
      this.bouton.setAttribute('aria-expanded', 'false');
      const etiquette = this.getAttribute('data-label');
      if (etiquette) this.bouton.setAttribute('aria-label', etiquette);
      this.bouton.innerHTML = '<span class="sirito-select__valeur"></span>';

      this.liste = document.createElement('ul');
      this.liste.className = 'sirito-select__liste';
      this.liste.setAttribute('role', 'listbox');
      this.liste.id = id + 'Liste';
      this.liste.hidden = true;
      if (etiquette) this.liste.setAttribute('aria-label', etiquette);

      this.elements = this.options.map((option, i) => {
        const li = document.createElement('li');
        li.className = 'sirito-select__option';
        li.setAttribute('role', 'option');
        li.id = id + 'Option' + i;
        li.textContent = option.textContent.trim();
        li.dataset.valeur = option.value;
        this.liste.appendChild(li);
        return li;
      });

      this.bouton.setAttribute('aria-controls', this.liste.id);

      // Le bouton prend la place exacte du <select> dans la rangée : posé en
      // fin d'élément, il passerait après le chevron, qui se retrouverait à
      // gauche de la valeur.
      this.select.insertAdjacentElement('afterend', this.bouton);
      this.appendChild(this.liste);
      this.peindre();
    }

    peindre() {
      this.bouton.querySelector('.sirito-select__valeur').textContent =
        this.options[this.index] ? this.options[this.index].textContent.trim() : '';
      this.elements.forEach((li, i) => {
        const choisi = i === this.index;
        li.setAttribute('aria-selected', choisi ? 'true' : 'false');
        li.classList.toggle('sirito-select__option--choisie', choisi);
      });
    }

    get ouverte() {
      return !this.liste.hidden;
    }

    ouvrir() {
      if (this.ouverte) return;
      this.liste.hidden = false;
      this.bouton.setAttribute('aria-expanded', 'true');
      this.survol = this.index;
      this.surligner(this.index);
    }

    fermer(rendreFocus) {
      if (!this.ouverte) return;
      this.liste.hidden = true;
      this.bouton.setAttribute('aria-expanded', 'false');
      this.bouton.removeAttribute('aria-activedescendant');
      this.elements.forEach((li) => li.classList.remove('sirito-select__option--survolee'));
      if (rendreFocus) this.bouton.focus();
    }

    surligner(i) {
      if (i < 0 || i >= this.elements.length) return;
      this.survol = i;
      this.elements.forEach((li, k) =>
        li.classList.toggle('sirito-select__option--survolee', k === i)
      );
      this.bouton.setAttribute('aria-activedescendant', this.elements[i].id);
      // Une liste plus haute que son cadre doit suivre le déplacement.
      this.elements[i].scrollIntoView({ block: 'nearest' });
    }

    choisir(i) {
      if (i < 0 || i >= this.options.length) return;
      this.index = i;
      this.peindre();
      this.fermer(true);
      if (this.select.selectedIndex === i) return;
      this.select.selectedIndex = i;
      // L'événement doit paraître authentique : c'est lui qui déclenche le
      // rechargement de la liste, écrit ailleurs.
      this.select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Saisir « pr » amène sur « Prix », comme sur une liste native.
    parLettres(lettre) {
      window.clearTimeout(this.horloge);
      this.recherche += lettre.toLowerCase();
      this.horloge = window.setTimeout(() => {
        this.recherche = '';
      }, DELAI_SAISIE);

      const depart = this.ouverte ? this.survol : this.index;
      for (let k = 1; k <= this.options.length; k += 1) {
        const i = (depart + k) % this.options.length;
        const texte = this.options[i].textContent.trim().toLowerCase();
        if (texte.startsWith(this.recherche)) {
          if (this.ouverte) this.surligner(i);
          else this.choisir(i);
          return;
        }
      }
    }

    brancher() {
      this.bouton.addEventListener('click', () => {
        if (this.ouverte) this.fermer(true);
        else this.ouvrir();
      });

      /* Empêcher le bouton de perdre le focus quand on appuie dans la liste.

         Sans cela, la séquence d'un vrai clic condamne la sélection : à
         l'enfoncement, le focus quitte le bouton pour rien — les options ne
         sont pas focalisables — ce qui déclenche le repli ci-dessous ; la
         liste disparaît, et le clic n'atteint jamais l'option puisqu'elle
         n'est plus affichée. Le défaut ne se voit qu'à la souris : un clic
         déclenché par script ne déplace pas le focus. */
      this.liste.addEventListener('mousedown', (event) => event.preventDefault());

      this.elements.forEach((li, i) => {
        li.addEventListener('click', () => this.choisir(i));
        li.addEventListener('mousemove', () => this.surligner(i));
      });

      this.addEventListener('keydown', (event) => {
        const touche = event.key;

        if (touche === 'Escape') {
          if (this.ouverte) {
            event.preventDefault();
            this.fermer(true);
          }
          return;
        }

        if (touche === 'Tab') {
          this.fermer(false);
          return;
        }

        if (touche === 'ArrowDown' || touche === 'ArrowUp') {
          event.preventDefault();
          if (!this.ouverte) {
            this.ouvrir();
            return;
          }
          const pas = touche === 'ArrowDown' ? 1 : -1;
          this.surligner(Math.min(Math.max(this.survol + pas, 0), this.elements.length - 1));
          return;
        }

        if (touche === 'Home' || touche === 'End') {
          if (!this.ouverte) return;
          event.preventDefault();
          this.surligner(touche === 'Home' ? 0 : this.elements.length - 1);
          return;
        }

        if (touche === 'Enter' || touche === ' ') {
          event.preventDefault();
          if (this.ouverte) this.choisir(this.survol);
          else this.ouvrir();
          return;
        }

        if (touche.length === 1 && /\S/.test(touche)) {
          this.parLettres(touche);
        }
      });

      // Un clic au-dehors referme, comme n'importe quel menu.
      document.addEventListener('click', (event) => {
        if (this.ouverte && !this.contains(event.target)) this.fermer(false);
      });

      /* Quitter le composant au clavier referme aussi. On juge sur l'élément
         réellement focalisé après coup, et non sur « relatedTarget » : ce
         dernier est vide dans plusieurs situations légitimes, ce qui refermait
         la liste à tort. */
      this.addEventListener('focusout', () => {
        window.setTimeout(() => {
          if (this.ouverte && !this.contains(document.activeElement)) this.fermer(false);
        }, 0);
      });
    }
  }

  customElements.define('sirito-select', SiritoSelect);
})();
